import { memo } from "react";
import { DisplayType } from "~/features/salesPartner/components/MapSection/Map/SPMap";
import { useTranslation } from "react-i18next";
import { styled } from "~/common/mui";

interface Props {
  onButtonClick: (displayType: DisplayType) => void;
  activeDisplayType: DisplayType;
}

const MapButtons = (props: Props) => {
  const { t } = useTranslation();
  const { onButtonClick, activeDisplayType } = props;
  return (
    <MapTypeButtonGroup>
      <MapTypeButton
        type="button"
        data-active={activeDisplayType === DisplayType.Schaeffler}
        onClick={() => onButtonClick(DisplayType.Schaeffler)}
      >
        {t("salesPartner.gmap.customButton.schaeff")}
      </MapTypeButton>
      <MapTypeButton
        type="button"
        data-active={activeDisplayType === DisplayType.Map}
        onClick={() => onButtonClick(DisplayType.Map)}
      >
        {t("salesPartner.gmap.customButton.map")}
      </MapTypeButton>
      <MapTypeButton
        type="button"
        data-active={activeDisplayType === DisplayType.Satellite}
        onClick={() => onButtonClick(DisplayType.Satellite)}
      >
        {t("salesPartner.gmap.customButton.satelite")}
      </MapTypeButton>
    </MapTypeButtonGroup>
  );
};

const MapTypeButtonGroup = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(1),
  right: theme.spacing(8.75),
}));

const MapTypeButton = styled("button")(({ theme }) => ({
  direction: "ltr",
  overflow: "hidden",
  textAlign: "center",
  height: theme.spacing(5),
  display: "table-cell",
  verticalAlign: "middle",
  position: "relative",
  color: theme.palette.text.primary,
  userSelect: "none",
  backgroundColor: theme.palette.common.white,
  padding: `0 ${theme.spacing(2.125)}`,
  borderRadius: theme.spacing(0.25),
  border: "none",
  backgroundClip: "padding-box",
  minWidth: theme.spacing(4.5),
  outline: "none",
  ...theme.typography.titleMedium,
  '&[data-active="true"], &:hover': {
    color: theme.palette.common.black,
  },
}));

export default memo(MapButtons);
